module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    on: {
      "click": _vm.scrollTop
    }
  }, [_c('img', {
    staticClass: "sd-arrow-top",
    attrs: {
      "src": "/static/material_icons/arrow_upward.png"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-753ffeeb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArrowTop.vue
// module id = 433
// module chunks = 1